import { createUseStyles } from '@glu/theming';

export default createUseStyles(({ nav: { horiz } }) => ({
  avatar: {
    float: 'left',
    height: 34,
    width: 34,
    margin: [3, 10, 0, 0],
    borderRadius: 100,
    background: '#003366',
    position: 'relative',
    overflow: 'hidden',
    '& svg': {
      position: 'absolute',
      top: 9,
      left: 9,
      height: 16,
      width: 16
    },
    '& img': {
      maxWidth: '100%'
    }

  },
  username: {
    fontSize: 18,
    lineHeight: '22px',
    display: 'block',
    position: 'relative',
    top: ({ subtext }) => (subtext ? 0 : 9)
  },
  icon: {
    marginLeft: 3
  },
  content: {
    float: 'left',
    textAlign: 'left'
  },
  userLink: {
    display: 'block',
    '&:hover $username': {
      color: horiz.usernameHoverColor,
      '& svg': {
        fill: horiz.usernameHoverColor
      }
    }
  },
  subtext: {
    fontSize: 14,
    lineHeight: '16px',
    display: 'block'
  }
}));
